import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GainsUiCommonsModule } from '@gainsystems/gains-ui-commons';
import { GAINS_VERSION } from 'app/shared/constants/common-items';
import { SsoLoginComponent } from './sso-login/sso-login.component';
import { GainsSharedModule } from 'app/shared/modules/gains-shared.module';

/**
 * LOGIN SCREEN COMPONENT
 *
 * Renders the SSO login flow along with common UI elements (logo, version info).
 */
@Component({
  selector: 'login-screen',
  imports: [CommonModule, GainsSharedModule, GainsUiCommonsModule, SsoLoginComponent],
  templateUrl: './login-screen.component.html',
  standalone: true,
  styleUrl: './login-screen.component.scss'
})
export class LoginScreenComponent {
  gainsVersion = GAINS_VERSION;
}
